import { FilterType5 } from 'app/stocks/models/filter-type-5';
import {GUID} from "../../shared/models/GUID-interface";

export class StocksFilter {
    constructor(

    ) {
        this.warehouses = null;
        this.skus = null;
        this.suppliers = null;
        this.extsuppliers = null;
        this.altgroup = null;
        this.category = null;
        this.group = null;
        this.subgroup1 = null;
        this.subgroup2 = null;
        this.subgroup3 = null;
        this.subgroup4 = null;
        this.subgroup5 = null;
        this.generalskucode = null;
        this.manager = null;
        this.manufacturer = null;
        this.brand = null;
        this.state = null;
        this.actionmovers = null;
        this.seasonmovers = null;
        this.speedmovers = null;
        this.topmovers = null;
        this.thrmovers = null;
        this.lspeedmovers = null;
        this.ltopmovers = null;
        this.lthrmovers = null;
        this.fresh = null;
        this.bufferlimits = null;
        this.storetype = null;
        this.warehousestatus = null;
        this.bufferzones = null;
        this.actionstatus = null;
        this.new = null;
        this.firstprice = null;
        this.blockedtoorder = null;
        this.supplierholiday = null;
        this.itemid = null;
        this.orderday = null;
        this.arriveday = null;
        this.scheduleExists= null;
        this.orderCycleType = null;
        this.schedulecycletype = null;
        this.scheduletype = null;
        this.buffer = new FilterType5();
        this.balance = new FilterType5();
        this.obvalue = new FilterType5();
        this.intransit = new FilterType5();
        this.otbvalue = new FilterType5();
        this.otbdiff = new FilterType5();
        this.order = new FilterType5();
        this.package = new FilterType5();
        this.shelfqnt = new FilterType5();
        this.safetystock = new FilterType5();
    }

    public warehouses: string[];
    public skus: string[];
    public suppliers: string[];
    public extsuppliers: string[];
    public altgroup: string[];
    public category: string[];
    public group: string[];
    public subgroup1: string[];
    public subgroup2: string[];
    public subgroup3: string[];
    public subgroup4: string[];
    public subgroup5: string[];
    public generalskucode: string[];
    public manager: string[];
    public manufacturer: string[];
    public brand: string[];
    public state: number[];
    public actionmovers: number[];
    public seasonmovers: number[];
    public speedmovers: number[];
    public topmovers: number[];
    public thrmovers: number[];
    public lspeedmovers: number[];
    public ltopmovers: number[];
    public lthrmovers: number[];
    public fresh: number[];
    public bufferlimits: number[];
    public storetype: number[];
    public warehousestatus: number[];
    public bufferzones: number[];
    public actionstatus: number[];
    public new: number[];
    public firstprice: number[];
    public blockedtoorder: number[];
    public supplierholiday: number[];
    public itemid: number[];
    public orderday: number[];
    public arriveday: number[];
    public scheduleExists: number[];
    public orderCycleType: number[];
    public schedulecycletype: number[];
    public scheduletype: number[];
    public buffer: FilterType5;
    public balance: FilterType5;
    public obvalue: FilterType5;
    public intransit: FilterType5;
    public otbvalue: FilterType5;
    public otbdiff: FilterType5;
    public order: FilterType5;
    public package: FilterType5;
    public shelfqnt: FilterType5;
    public safetystock: FilterType5;
}

export class StocksFilterGUID implements GUID{
    constructor(public readonly GUID: string, public stocksFilter: StocksFilter) {

    }

}



// WEBPACK FOOTER //
// ./src/app/stocks/models/stocks-filter.ts